// Canonical home for community membership-state types.
//
// `MemberStatus` lives here (and not in groups-layer) because membership state
// is a cross-layer concept: groups-layer owns group definitions, but the user's
// status against a group is read by community-user-layer, members-layer,
// comments-layer, posts-layer, learning-layer, and more.
//
// Keep this file free of imports from any community sub-layer to avoid cycles.

export enum MemberStatus {
  ACTIVE = 'Active',
  REQUESTED = 'Requested',
  PAYMENT_INITIATED = 'PaymentInitiated',
  PAYMENT_RECEIVED = 'PaymentReceived',
  BANNED = 'Banned',
}
